const debug = process.env.NODE_ENV !== 'production'
  
module.exports = {
  debug,
  baseUrl: debug ? '/ui-trunk/' : '/ui-dev/',
}
